import React from "react";
import Weather from "./Weather.js"
import './App.css';

export default function App() {
  return (
    <div className="App">
      <div className="container">
    
    <Weather defaultCity="Cape Town"/>
      <footer>
      My name is Sibongile Ncapayi and I am hosting the code on my {" "}
        <a href = "https://github.com/SboshN/sbosh-react-weather-forecast" rel="noreferrer" target="_blank">
           GitHub account
        </a>
        {" "} and the project is live on my {" "} 
        <a href = "https://sbongile-ncapayi-weather.netlify.app/" rel="noreferrer" target="_blank">
           Netlify account
        </a>
        {"."}
      </footer>
      </div>
    </div>
  );
}


